import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import PrismicRichText from "../components/PrismicRichText";
import * as colors from "../constants/colors";

const StlRoot = styled.section`
  overflow: hidden;

  @media (min-width: 900px) {
    max-height: 767px;
  }
`;

const StlInner = styled.div`
  margin: 0 auto;
`;

const StlImageWrap = styled.figure`
  position: relative;
  margin: 0;
  width: 100%;
  overflow: hidden;
  max-height: 767px;

  @media (min-width: 900px) {
    max-height: 767px;
  }
`;

const StlCopy = styled.div`
  position: absolute;
  left: 50%;
  bottom: 29px;
  z-index: 2;
  width: 80%;
  padding: 10px;
  background: ${colors.white};
  color: #c96f3d;
  text-align: center;
  transform: translateX(-50%) rotate(-4deg);
  box-shadow: 0 14px 28px rgba(65, 39, 18, 0.18);

  h1,
  h2,
  h3,
  h4,
  p {
    margin: 0;
    text-align: left;
    letter-spacing: -0.2rem;
    line-height: 0.96;
  }

  p {
    color: inherit;
    font-family: "Gotham Bold", sans-serif;
    font-size: clamp(2.8rem, 4.8vw, 5.8rem);
  }

  @media (min-width: 550px) {
    width: 60%;
    transform: translate(-50%, -52%) rotate(-4deg);
  }

  @media (min-width: 900px) {
    top: 50%;
    bottom: auto;
    width: min(60%, 860px);
    padding: 34px 36px 28px;
    transform: translate(-50%, 44%) rotate(-4deg);
    width: auto;
    h2 {
      font-size: 48px;
    }
  }
`;

const StlImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.3);
`;

const StlImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const CopyImageSlice = (slice) => {
  const primary = get(slice, "primary", {});
  const heading = get(primary, "main_content");
  const imageUrl = get(primary, "image.url");
  const imageAlt = get(primary, "image.alt") || "Section image";

  return (
    <StlRoot>
      <StlInner>
        <StlImageWrap>
          {imageUrl && <StlImage src={imageUrl} alt={imageAlt} />}
          <StlImageOverlay />
          <StlCopy>
            {heading && (
              <PrismicRichText
                render={heading}
                elements={{
                  heading2: ({ children, key }) => (
                    <h2 key={key}>{children}</h2>
                  ),
                }}
              />
            )}
          </StlCopy>
        </StlImageWrap>
      </StlInner>
    </StlRoot>
  );
};

export default CopyImageSlice;
